"use client";

import { usePathname } from "next/navigation";
import S from "../index.module.scss";

interface HeaderMobileTitleProps {
  labels: Record<string, string>;
  profileLabel: string;
}

const getTitleByPathname = (pathname: string, labels: Record<string, string>, profileLabel: string) => {
  if (pathname === "/profile" || pathname.startsWith("/profile/")) {
    return profileLabel;
  }

  const activeItem = Object.entries(labels).find(([href]) => pathname === href || pathname.startsWith(`${href}/`));

  return activeItem?.[1] ?? "";
};

const HeaderMobileTitle = ({ labels, profileLabel }: HeaderMobileTitleProps) => {
  const pathname = usePathname();
  const title = getTitleByPathname(pathname, labels, profileLabel);

  if (!title) {
    return null;
  }

  return (
    <div className={S.mobileTopHeader}>
      <div className={S.mobileTopHeaderInner}>
        <h1 className={S.mobileTopHeaderTitle}>{title}</h1>
      </div>
    </div>
  );
};

export default HeaderMobileTitle;
